
const ProjectsData = [
    {
        title: "MyShow",
        image: "/Img/myshow1.png",
        skills: "ReactJS, Tailwind CSS, TMDB API, NPM Packages, and Razorpay.",
        live: "https://my-show-rj.vercel.app/",
        github: "https://github.com/RajatJ00/MyShow",
    },
    {
        title: "Space Tourism",
        image: "/Img/Space_Tourism.jpg",
        skills: "ReactJS, Tailwind CSS, and NPM",
        live: "https://space-tourism-rj.vercel.app/",
        github: "https://github.com/RajatJ00/SpaceTourism",
    },
    {
        title: "Ayurveda App",
        image: "/Img/ayurveda.png",
        skills: "Android Studio, Java and XML",
        live: "",
        github: "https://github.com/RajatJ00/AyurvedaApp",
    },
    {
        title: "Coaching Class Management System",
        image: "/Img/ccms.png",
        skills: "dotNET",
        live: "",
        github: "https://github.com/RajatJ00/CCMS",
    },
    {
        title: "Booklist",
        image: "/Img/booklist.png",
        skills: "ReactJS, Postman and API",
        live: "",
        github: "https://github.com/RajatJ00/Booklist",
    },
    {
        title: "Zomato-Clone",
        image: "/Img/zomato.png",
        skills: "HTML, CSS, JavaScript and NPM packages",
        live: "https://zomato-rj.vercel.app/",
        github: "https://github.com/RajatJ00/ZomatoClone",
    },
]
export default ProjectsData;